import React from 'react';

import SVG from '../nord-ui/SVG';
import { ISvg } from '../nord-ui/SVG/interface';

export interface ISvgProps extends ISvg {
  title: string;
  lazy?: boolean;
  noDefaultSize?: boolean;
  lazyOptions?: any;
}

const OurSVG: React.FC<ISvgProps> = ({
  noDefaultSize = false,
  width = 16,
  height = 16,
  ...rest
}) => <SVG {...rest} {...(!noDefaultSize ? { width, height } : {})} />;

export default OurSVG;
